import React, { useEffect, useState } from 'react'
import MainFooter from '../Components/footer/MainFooter'
import TopNavigation from '../Components/navigation/TopNavigation'
import axios from 'axios';
import facebookImage from './../assets/mac-facebook.png';
import instagramImage from './../assets/phone-dripp-prop.png';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import * as CONSTANTS from "../CONSTANTS";
import { Helmet } from 'react-helmet';

function ContactUs() {
  const [activeIndex, setActiveIndex]                         = useState(0);

  const [name, setName]                                       = useState('');
  const [surname, setSurname]                                 = useState('');
  const [email, setEmail]                                     = useState('');
  const [phone, setPhone]                                     = useState('');
  const [message, setMessage]                                 = useState('');
  const [responseMessage, setResponseMessage]                 = useState('');
  const [submissionStatus, setSubmissionStatus]               = useState(null); // 'success', 'error', 'submitting'

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev === 0 ? 1 : 0));
    }, 15000); // Toggle every 15 seconds

    return () => clearInterval(interval); // Clean up on unmount
  }, []);
  
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default browser form submission

    setSubmissionStatus('submitting'); // Indicate that submission is in progress

    const messageContact = {
      name: name,
      surname: surname,
      email: email,
      message: message,
      phone: phone,
    };

    try {
      const response = await axios.post(CONSTANTS.API_URL +"settings/message/v1/create", messageContact);
 
      console.log('Form submitted successfully:', response.data);
      setResponseMessage(response.data.message);
            setSubmissionStatus('success');
            // Optionally, clear the form fields after successful submission
            setName('');
            setSurname('');
            setEmail('');
            setPhone('');
            setMessage('');
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmissionStatus('error');
      // You might want to display a more specific error message to the user
    }
  };

  return (
     <div className="main-layer">

      <Helmet>
              <title>Lovedripp - Contact Us </title>
      </Helmet>
     
       <TopNavigation title={"Contact Us"} classBack="full-white"/>
        <div className="content-layer">
          <div className="section-item">
            <div className="container">
                <div className="short-style-banner">
                   <div className="head-container-widget">
                    <h2>Contact Us</h2>
                    <div className="sub-head-widget">
                      Get in touch with us.
                    </div>
                   </div>
                </div>
            </div>
          </div>

          <div className="section-item">
            <div className="container">
              <div className="row">
                <div className="col-md-7">
                  <div className="widget-box">
                    <h1 className="pdhorizontal1">Your responsibility is to enjoy a special wedding.</h1>
                      <div className="video-container">
                        <video autoPlay loop muted playsInline className="vid-element">
                          <source src="https://tsdevcut.co.za//videos/lovedrippv/landscape_3840_2160_place.mp4" type="video/mp4" />
                        </video>
                      </div>                      
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="widget-box">                  
                       <div className="contact-form-container">
                         <h3>Ask us anything?</h3>
                          <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                              <label htmlFor="name" className="form-label">Name <span className="text-danger">*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="surname" className="form-label">Surname</label>
                              <input
                                type="text"
                                className="form-control"
                                id="surname"
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="phone" className="form-label">Phone Number</label>
                              <input
                                type="tel"
                                className="form-control"
                                id="phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="message" className="form-label">Message <span className="text-danger">*</span></label>
                              <textarea
                                className="form-control"
                                id="message"
                                rows="5"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                              ></textarea>
                            </div>
                            <button
                              type="submit"
                              className="btn btn-main"
                              disabled={submissionStatus === 'submitting'} // Disable button during submission
                            >
                              {submissionStatus === 'submitting' ? 'Submitting...' : 'Submit'}
                            </button>

                            {/* Submission feedback */}
                            {submissionStatus === 'success' && (
                              <div className="alert alert-success mt-3" role="alert">
                                {responseMessage}
                              </div>
                            )}
                            {submissionStatus === 'error' && (
                              <div className="alert alert-danger mt-3" role="alert">
                                Failed to send message. Please try again.
                              </div>
                            )}
                          </form>
                        </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="section-item-verse">
            <div className="row row-unset">
               <div className={`col-md-6 col-social fs ${activeIndex === 0 ? "introvet-widget" : ""}`}>
                    <div className="mid-social mid-facebook">
                        <div className="image-top">
                          <img src={facebookImage} className="face-social" />
                        </div>
                        <div className="social-info-text hor-social">
                            <p>
                              Visit our facebook page.
                            </p>
                            <Link to={"https://facebook.com/LoveDripp"} 
                              target="_blank"
                              className="btn btn-social-place">
                              <span className="social-icon">
                                <FaFacebook />
                              </span>
                              <span>Facebook</span>
                            </Link>
                        </div>                       
                    </div>
               </div>
               <div className={`col-md-6 col-social insta ${activeIndex === 1 ? "introvet-widget" : ""}`}>
                    <div className="mid-social mid-instagram">
                       <div className="side-image">
                        <img src={instagramImage} className="insta-social" />
                       </div>
                       <div className="social-info-text ver-social">
                            <p>You could also come and enjoy our instagram page.</p>
                            <Link to={"https://www.instagram.com/lovedripp"} 
                              target="_blank"
                              className="btn btn-social-place">
                              <span className="social-icon">
                                <FaInstagram />
                              </span>
                              <span>instagram</span>
                            </Link>
                       </div>
                    </div>
               </div>
            </div>
          </div>
        </div>
      <MainFooter />
    </div>
  )
}

export default ContactUs